export function initParticle(name, config) {
  return {
    type: 'INIT_PARTICLE',
    name,
    config
  }
}

export function setColour(name, colour) {
  return {
    type: 'SET_COLOUR',
    name,
    colour
  }
}

export function setParticleNumber(name, number) {
  return {
    type: 'SET_PARTICLE_NUMBER',
    name,
    number
  }
}


// WEBPACK FOOTER //
// ./src/actions/ParticlesActions.js